import { useEffect, useState, useRef } from "react";
import { checkIfAuctionItemEnded } from "@/lib/auctions";

/**
 * Delays the "ended" state by a short period to allow a fresh poll
 * to return potentially extended end times before showing "Avslutad".
 */
const CONFIRM_DELAY = 3000;

const useConfirmedEnded = (
  itemEndTime: any,
  serverTime: any,
  onRequestPoll?: () => void
) => {
  const hasEndedByTime = checkIfAuctionItemEnded(itemEndTime, serverTime);
  // Start confirmed if already ended on mount (e.g. old auction)
  const [hasEndedConfirmed, setHasEndedConfirmed] = useState(() => hasEndedByTime);
  const polledRef = useRef(false);

  useEffect(() => {
    if (hasEndedByTime && !hasEndedConfirmed) {
      if (!polledRef.current && onRequestPoll) {
        polledRef.current = true;
        onRequestPoll();
      }
      const timeout = setTimeout(() => {
        setHasEndedConfirmed(true);
      }, CONFIRM_DELAY);
      return () => clearTimeout(timeout);
    }
    if (!hasEndedByTime) {
      setHasEndedConfirmed(false);
      polledRef.current = false;
    }
  }, [hasEndedByTime, hasEndedConfirmed, onRequestPoll]);

  return hasEndedByTime && hasEndedConfirmed;
};

export default useConfirmedEnded;
